(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  function moveSeoBlurbBelowLoadMore() {
    // This is the container holding your h5 > span SEO blurb
    const seo = document.querySelector('.rte--collection-desc');
    if (!seo) return;

    // Initialize attributes for flash-control CSS
    if (!seo.dataset.seoMoveInit) {
      seo.dataset.seoMoveInit = "1";
      seo.dataset.seoMoved = "0";
    }

    // The "Click To Load More" wrapper created by Ajaxinate
    const pager = document.querySelector('#AjaxinatePagination');

    if (pager) {
      // If it's already directly after pager, we're done
      if (seo.previousElementSibling !== pager) {
        pager.insertAdjacentElement('afterend', seo);
      }
      seo.dataset.seoMoved = "1";
      seo.style.visibility = "visible";
      return;
    }

    // If there is no pager (last page / no pagination), keep it visible
    // and place it near the bottom of the collection ajax area
    const fallbackParent =
      document.querySelector('#CollectionAjaxResult') ||
      document.querySelector('#CollectionAjaxContent') ||
      seo.parentElement;

    if (fallbackParent && seo.parentElement !== fallbackParent) {
      fallbackParent.appendChild(seo);
    }

    seo.dataset.seoMoved = "1";
    seo.style.visibility = "visible";
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', moveSeoBlurbBelowLoadMore);

  // Run after Ajaxinate loads more
  document.addEventListener('ajaxinate:loaded', moveSeoBlurbBelowLoadMore);

  // Run when Shopify re-renders a section (theme editor / dynamic sections)
  document.addEventListener('shopify:section:load', moveSeoBlurbBelowLoadMore);

  // Watch for DOM replacement from filters / ajax renders
  let raf = 0;
  const observer = new MutationObserver(() => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = 0;
      moveSeoBlurbBelowLoadMore();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also run immediately (in case script loads after DOMContentLoaded)
  moveSeoBlurbBelowLoadMore();
})();

  } catch(e) { console.error(e); }
})();
})();
